const {BASE_URL} = require('./client');

const UPLOAD = BASE_URL+'/api/upload';
const MOBILE = BASE_URL+'/api/mobile';
const DELETE_ALL = BASE_URL+'/api/deletealldata';
module.exports = {
    UPLOAD,
    MOBILE,
    DELETE_ALL
}